<template>
  <div class="user-container">
    <div class="user-header">
      <div class="project-name">唐光明鲜花快运</div>
      <div class="avatar-wrapper">
        <img class="avatar" :src="avatar" />
      </div>
      <div class="user-info">
        <div class="user-name">我</div>
        <div class="user-phone">{{ phone }}</div>
      </div>
    </div>

    <!-- <div class="stats-card">
      <div class="stat-item">
        <div class="stat-value">{{ stats.unpaidCount }}</div>
        <div class="stat-label">待支付</div>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.paidCount }}</div>
        <div class="stat-label">已支付</div>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.inTransitCount }}</div>
        <div class="stat-label">配送中</div>
      </div>
    </div> -->

    <!-- 订单管理 - 只对顾客显示 -->
    <div class="menu-group" v-if="!isEmployee">
      <div class="menu-title">订单管理</div>
      <div class="menu-list">
        <div class="menu-item" @click="goToUnpaidBills">
          <div class="menu-icon">
            <i class="iconfont icon-list"></i>
          </div>
          <div class="menu-name">待支付账单</div>
          <div class="menu-arrow">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="menu-item" @click="goToPaidBills">
          <div class="menu-icon">
            <i class="iconfont icon-paid"></i>
          </div>
          <div class="menu-name">已支付账单</div>
          <div class="menu-arrow">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <!-- 员工功能 - 只对员工显示 -->
    <div class="menu-group" v-if="isEmployee">
      <div class="menu-title">员工功能</div>
      <div class="menu-list">
        <div class="menu-item" @click="goToDeliveryList">
          <div class="menu-icon">
            <i class="iconfont icon-logistics"></i>
          </div>
          <div class="menu-name">送货列表</div>
          <div class="menu-arrow">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>

    <div class="app-version">
      当前版本：v1.0.0
    </div>
  </div>
</template>

<script>
import { Icon, Dialog, Toast } from 'vant'
import { getUserInfo } from '@/api/user'

export default {
  name: 'User',
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      avatar: 'https://img01.yzcdn.cn/vant/cat.jpeg',
      phone: '',
      isEmployee: false,
      stats: {
        unpaidCount: 3,
        paidCount: 12,
        inTransitCount: 2
      }
    }
  },
  created() {
    // 组件创建时直接获取手机号
    this.fetchPhoneNumber()
  },
  activated() {
    // keep-alive 缓存的组件在激活时重新获取用户信息
    // 使用 nextTick 确保页面先渲染完成，再请求数据，避免阻塞页面切换
    this.$nextTick(() => {
      this.fetchPhoneNumber()
    })
  },
  methods: {
    goToUnpaidBills() {
      this.$router.push('/')
    },
    goToPaidBills() {
      this.$router.push('/paid')
    },
    goToDeliveryList() {
      this.$router.push('/delivery')
    },
    fetchPhoneNumber() {
      // 直接调用getUserInfo接口获取手机号和用户身份
      getUserInfo().then(res => {
        if (res.code === 200 && res.user) {
          this.phone = res.user.phonenumber || '未设置手机号'
          this.isEmployee = res.user.employee === true
          if (res.user.avatar) {
            this.avatar = res.user.avatar
          }
        }
      }).catch(err => {
        console.error('获取用户信息失败', err)
        this.phone = '获取失败'
      })
    }
  }
}
</script>

<style scoped>
.user-container {
  padding-bottom: 50px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.user-header {
  background: linear-gradient(to right, #1989fa, #39b9fa);
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.project-name {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  color: white;
}

.avatar-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.6);
  margin-bottom: 15px;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  text-align: center;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.user-phone {
  font-size: 14px;
  opacity: 0.8;
}

.stats-card {
  background: white;
  border-radius: 10px;
  margin: -20px 15px 15px;
  padding: 15px;
  display: flex;
  justify-content: space-around;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
}

.stat-item {
  flex: 1;
  text-align: center;
}

.stat-divider {
  width: 1px;
  background-color: #eee;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 12px;
  color: #999;
}

.menu-group {
  background: white;
  border-radius: 10px;
  margin: 15px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.menu-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #1989fa;
  font-size: 18px;
}

.menu-name {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.menu-arrow {
  color: #ccc;
}

.app-version {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 30px;
}
</style>
